import { BrandingImage, BrandingStyle, useModel } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "components/shared/containers/PageLayoutContainer";
import PageFooterView from "components/shared/views/PageFooterView";
import PageHeaderView, { MobilePageHeaderView } from "components/shared/views/PageHeaderView";
import React from "react";
import { ImageAsset } from "res";

import "./styles.css";
import "./mobile.css";
import Util from "classes/Util";
import { MainNavView, UtilityNavView } from "components/shared";


/**
 * @function TransparentPageContentView
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <PageContentView>
 *  <LeftColumn />
 *  <RightColumn />
 * </PageContentView>
 */
export default function TransparentPageContentView(props) {
    const{ className  = ""} = props;
    const showHeader = props.showHeader ?? true;
    const hidePageBody = props.hidePageBody ?? false;
    const { branding } = useModel();
    const { options } = branding;
    const fdicLogoUnderFILogoType = options.fdic_fi_logo_abi22;
    let hasFDICLogoUnderFILogo = fdicLogoUnderFILogoType !== "undefined" && fdicLogoUnderFILogoType !== "None";
    let fdicImageID = "FDICDigitalSignWhite";

    if (fdicLogoUnderFILogoType === "Colored (White BG)") fdicImageID = "FDICDigitalSign";

    // START: Get branding from mabi23 if set.
    const mabi23Branding = Util.getMABI23Branding();

    if (mabi23Branding && mabi23Branding.options.mobile_fdic_mabi23 !== "undefined") {
        const mabi23Options = mabi23Branding.options;
        hasFDICLogoUnderFILogo = mabi23Options.mobile_fdic_mabi23 !== "None";
        fdicImageID = mabi23Options.mobile_fdic_mabi23 === "Colored (White BG)" ? "FDICDigitalSign" : "FDICDigitalSignWhite";
    }
    // END: Get branding from mabi23 if set.

    return (
        <div className={`payment-page-content-view ${className}`}>
            {showHeader &&
                <>
                    <PageHeaderView>
                        <div className={`upper-header-wrapper flex-container flex-horizontal align-center
                            ${hasFDICLogoUnderFILogo ? "fdic-logo-adjusted" : ""}`}>
                            <div className={`flex-width logo-container ${hasFDICLogoUnderFILogo ? "fdic-logo-adjusted" : ""}`}>
                                {!hasFDICLogoUnderFILogo &&
                                    <a href="#/accountSummary">
                                        <BrandingImage id="header_logo_abi22" className="page-header-logo" />
                                    </a>
                                }
                                {hasFDICLogoUnderFILogo &&
                                    <div className="flex-container flex-vertical">
                                        <a href="#/accountSummary">
                                            <BrandingImage id="header_logo_abi22" className="page-header-logo fdic-logo-adjusted" />
                                        </a>
                                    </div>
                                }
                            </div>
                            <UtilityNavView />
                        </div>
                        {hasFDICLogoUnderFILogo &&
                            <div className="fdic-logo-container">
                                <ImageAsset id={fdicImageID} className={"fdic-logo"} />
                            </div>
                        }
                        <MainNavView />
                    </PageHeaderView>
                    <MobilePageHeaderView />
                    {/* The fdic logo is shown beneath the header view in mobile view. */}
                    {hasFDICLogoUnderFILogo &&
                        <div className="fdic-logo-container show-on-mobile">
                            <ImageAsset id={fdicImageID} className={"fdic-logo f"} />
                        </div>
                    }
                </>
            }

            <div className="payment-page-content-view-content flex-container flex-vertical" >
                <PageLayoutContainer className={hidePageBody ? "visibility-hidden" : ""}>
                    {props.children}
                </PageLayoutContainer>
            </div>
            {!hidePageBody && <PageFooterView />}

        </div>
    );
}